module.exports = __webpack_public_path__ + "static/media/fly0144.a0d7056a.webp";